export default function NumFormat(value, type = '.00') {
  switch (type) {
    default:
      if (value.toString().indexOf ('.') !== -1)  {
        return value.toLocaleString();
      } else {
        return value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }
    case '.00':
      if (typeof value === 'string') {
        value = value.replace(/[^\d.]/g, "").replace(/^\./g, "").replace(/\.{2,}/g, ".").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      }
      let toFixedNum = Number(value).toFixed(3);
      return toFixedNum.substring(0, toFixedNum.toString().length - 1);
    case '00':
      if (typeof value === 'string') {
        value = value.replace(/[^\d]/g, '');
      }
      value = Math.ceil(value/100) * 100;
      return Number(value);
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/NumFormat.js